export default __webpack_public_path__ + "static/any-clip-99fbb2ae4f4c139299441bd3fbc1d3f2.svg";